<template>
  <div class="regulation-update">
    <BaseIcon icon="ic_info" width="48px" height="48px" :colors="iconColor" />
    <BaseText size="sm">{{ disclaimer }}</BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { getString } from '@/modules/common/helpers/resources';

@Component({ components: { BaseIcon, BaseText } })
export default class RegulationUpdateInfo extends Vue {
  private disclaimer = getString('account_update_cvm_disclaimer');
  private iconColor = NebraskaColors.statusInfo;
}
</script>

<style lang="less" scoped>
.regulation-update {
  display: flex;
  align-items: center;
  margin-bottom: @size-spacing-x600;
  > * {
    margin: 0 @size-spacing-x500;
  }
}
</style>
